// base
import { createSlice } from '@reduxjs/toolkit';

// actions
import { RISK_ASSESSMENT_RISK_DATABASE_SLICE_NAME } from '../actions';

// models
import type { RiskDatabaseState } from '../models';

// thunks
import { getRiskDatabaseActivity, getRiskDatabaseHazard, getRiskDatabaseWorks } from '../thunks';

// initialState
const initialState: RiskDatabaseState = {
  worksList: [],
  activityList: [],
  hazardList: []
};

// createSlice
const riskDatabaseSlice = createSlice({
  name: RISK_ASSESSMENT_RISK_DATABASE_SLICE_NAME,
  initialState,
  reducers: {
    setWorksList: (state, action) => {
      state.worksList = action.payload;
    },
    setActivityList: (state, action) => {
      state.activityList = action.payload;
    },
    setHazardList: (state, action) => {
      state.hazardList = action.payload;
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getRiskDatabaseWorks.fulfilled, (state, action) => {
        const { resultList } = action.payload;
        state.worksList = resultList;
      })
      .addCase(getRiskDatabaseActivity.fulfilled, (state, action) => {
        const { resultList } = action.payload;
        state.activityList = resultList;
      })
      .addCase(getRiskDatabaseHazard.fulfilled, (state, action) => {
        const { resultList } = action.payload;
        state.hazardList = resultList;
      })
});

export const riskDatabase = riskDatabaseSlice.name;
export const riskDatabaseReducer = riskDatabaseSlice.reducer;
export const riskDatabaseSliceActions = riskDatabaseSlice.actions;
export default riskDatabaseSlice.reducer;
